import { render, staticRenderFns } from "./GambleOptions.vue?vue&type=template&id=1a07035e&scoped=true&"
import script from "./GambleOptions.vue?vue&type=script&lang=js&"
export * from "./GambleOptions.vue?vue&type=script&lang=js&"
import style0 from "./GambleOptions.vue?vue&type=style&index=0&id=1a07035e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07035e",
  null
  
)

export default component.exports